import axios from 'axios';

export const PO_API = `${process.env.REACT_APP_BACKEND_URL}/api/purchase-orders`;
export const poAuth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
export const poPdfUrl = (n) => `${PO_API}/${n}/pdf?token=${localStorage.getItem('token')}`;
export const money = (v) => (v === null || v === undefined || v === '' ? '—' : `$${Number(v).toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);

export const fmtPoDate = (s) => {
  if (!s) return '—';
  const m = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(String(s).trim());
  if (m) {
    const d = new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
    return d.toLocaleDateString('en-CA', { month: 'short', day: 'numeric', year: 'numeric' });
  }
  const d = new Date(s);
  return isNaN(d) ? String(s) : d.toLocaleDateString('en-CA', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const todayDMY = () => {
  const d = new Date();
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
};

export const fetchVendors = async (q) => (await axios.get(`${PO_API}/vendors`, { ...poAuth(), params: { q } })).data;

export const INPUT = 'w-full px-3 py-2 bg-white border border-slate-300 rounded-lg text-sm text-slate-900 placeholder-slate-400 outline-none focus:border-sky-500 focus:ring-2 focus:ring-sky-100';
export const LABEL = 'block text-[11px] font-bold uppercase tracking-wider text-slate-500 mb-1';
export const BTN_PRIMARY = 'inline-flex items-center gap-1.5 px-4 py-2 rounded-lg bg-slate-900 hover:bg-sky-800 text-white text-sm font-bold shadow-sm transition-colors disabled:opacity-50 disabled:cursor-not-allowed';
export const BTN_GHOST = 'inline-flex items-center gap-1.5 px-3 py-2 rounded-lg bg-white border border-slate-300 hover:bg-slate-50 text-slate-800 text-sm font-semibold transition-colors disabled:opacity-50';
